"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[51357],{

/***/ 465385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ LogoLoading; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(855271);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(179185);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/assets/images/loading.es.js
var loading = "https://shopfront-cdn.tekoapis.com/static/0aca01576f2159f6.svg";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/Loading/LogoLoading.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = styled_es/* styled.div */.z.div((props) => `
    width: ${props.size}px;
    height: ${props.size}px;
    position: relative;
  `);
const Logo = (0,styled_es/* styled */.z)(LazyImage_es/* LazyImage */.w)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;
const StyledLazyImage = (0,styled_es/* styled */.z)(LazyImage_es/* LazyImage */.w)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 3px;
  right: 0;
`;
const LogoLoading = (_a) => {
  var _b = _a, {
    size = 80,
    logo = ""
  } = _b, props = __objRest(_b, [
    "size",
    "logo"
  ]);
  return /* @__PURE__ */ react.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    size
  }), logo && /* @__PURE__ */ react.createElement(Logo, {
    width: size / 2,
    height: size / 2,
    src: logo
  }), /* @__PURE__ */ react.createElement(StyledLazyImage, {
    width: size,
    height: size,
    src: loading
  }));
};




/***/ }),

/***/ 804393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ MiniSlides; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(732553);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(179185);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(428247);
/* harmony import */ var _PreLoad_PreLoad_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(301286);
/* harmony import */ var _CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(528938);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  border-radius: 0.5rem;
  overflow: hidden;
`;
const MiniSlides = (_a) => {
  var _b = _a, {
    banners = [],
    isLoading = false,
    regionName,
    height = 140,
    width = 1232
  } = _b, props = __objRest(_b, [
    "banners",
    "isLoading",
    "regionName",
    "height",
    "width"
  ]);
  if (isLoading)
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_PreLoad_PreLoad_es_js__WEBPACK_IMPORTED_MODULE_2__/* .PreLoad */ .b, {
      height,
      isLoading
    });
  if (!isLoading && !banners.length)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Swiper */ .t, {
    autoplay: {
      delay: 2500
    },
    slidesPerView: 1,
    loop: true,
    hasNavigation: true
  }, banners.map((banner, index) => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", __spreadValues({
      key: index,
      className: "swiper-slide"
    }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_4__/* .getTrackingData */ .O5)({
      isTrackContent: true,
      regionName: regionName || "topBanner",
      contentName: banner.campaignName,
      target: banner.targetPath,
      index
    })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_5__/* .CustomLink */ .x, {
      targetPath: banner.targetPath
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .LazyImage */ .w, {
      borderRadius: 8,
      height,
      src: banner.image,
      alt: banner.campaignName,
      width,
      imageWidth: width,
      hover: "zoom",
      cover: true
    })));
  })));
};




/***/ }),

/***/ 301286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ PreLoad; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _Loading_LogoLoading_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(465385);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div`
  position: relative;
  border-radius: 0.5rem;
  background: #fff;
  height: ${(props) => props.height + "px"};
  user-select: none;
`;
const StyledLogoLoading = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_Loading_LogoLoading_es_js__WEBPACK_IMPORTED_MODULE_2__/* .LogoLoading */ .h)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
`;
const PreLoad = (_a) => {
  var _b = _a, {
    height,
    isLoading,
    hideLogo = false,
    logo
  } = _b, props = __objRest(_b, [
    "height",
    "isLoading",
    "hideLogo",
    "logo"
  ]);
  if (!isLoading)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    height
  }), !hideLogo && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLogoLoading, {
    logo
  }));
};




/***/ }),

/***/ 85468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ Pagination; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(428247);
/* harmony import */ var _atoms_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(650983);
/* harmony import */ var _atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46610);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const LEFT_PAGE = "LEFT";
const RIGHT_PAGE = "RIGHT";
const StyledPagination = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ul */ .Z.ul`
  margin-top: 0;
  margin-bottom: 0;
  width: fit-content;
  display: flex;
`;
const StyledPaginationBtn = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].li */ .Z.li(({ theme, disabled, active }) => `
    pointer-events: ${disabled ? "none" : "auto"};
    display: inline-block;
    ${active && `color: #fff;
      border-color: ${theme.brand.primary};
      &:hover {
        color: ${theme.brand.primary};
      }`}
  `);
const PageLink = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_atoms_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z)(({ theme, active }) => `
  min-width: 36px;
  height: 36px;
  text-align: center;
  box-shadow: none;
  border-color: #ced4da;
  color: ${theme.brand.primary};
  font-size: 12px;
  background-color: #fff;
  padding: 8px;
  margin: 5px;
  &:hover {
    background-color: #f4f4f4;
  }
  ${active && `color: #fff;
    background-color: ${theme.brand.primary};
    border-color: ${theme.brand.primary};
    border-radius: 4px;
    &:hover {
      color: ${theme.brand.primary};
      background-color: ${theme.brand.primary};
      color: #fff;
      border-color: ${theme.brand.primary};
    }
    `}
`);
const DotItem = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].li */ .Z.li`
  pointer-events: none;
  display: flex;
  min-width: 36px;
  height: 36px;
  color: ${(props) => props.theme.brand.primary};
  padding: 8px;
  margin: 5px;
  font-size: 12px;
  justify-content: center;
`;
const PaginationButtonWrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div`
  z-index: 1;
  display: inline-block;
`;
const range = (from, to, step = 1) => {
  return Array.from(Array(to - from + 1).keys()).map((item) => item * step + from);
};
const Pagination = (_a) => {
  var _b = _a, {
    totalRecords = 0,
    pageLimit = 30,
    pageNeighbours = 2,
    onPageChanged,
    currentPage
  } = _b, props = __objRest(_b, [
    "totalRecords",
    "pageLimit",
    "pageNeighbours",
    "onPageChanged",
    "currentPage"
  ]);
  const totalPages = Math.ceil(totalRecords / pageLimit);
  const gotoPage = (page) => {
    onPageChanged(page);
  };
  const handleClick = (page, e) => {
    e.preventDefault();
    gotoPage(page);
  };
  const handleMoveLeft = (e) => {
    e.preventDefault();
    gotoPage(currentPage - 1);
  };
  const handleMoveRight = (e) => {
    e.preventDefault();
    gotoPage(currentPage + 1);
  };
  const fetchPageNumbers = () => {
    const totalNumbers = pageNeighbours * 2 + 3;
    const totalBlocks = totalNumbers + 2;
    if (totalPages > totalBlocks) {
      let pages2 = [];
      const curr = currentPage > totalPages ? totalPages : currentPage;
      const leftBound = curr - pageNeighbours;
      const rightBound = curr + pageNeighbours;
      const beforeLastPage = totalPages - 1;
      const startPage = leftBound > 2 ? leftBound : 2;
      const endPage = rightBound < beforeLastPage ? rightBound : beforeLastPage;
      pages2 = range(startPage, endPage);
      const pagesCount = pages2.length;
      const singleSpillOffset = totalNumbers - pagesCount - 1;
      const leftSpill = startPage > 2;
      const rightSpill = endPage < beforeLastPage;
      const leftSpillPage = LEFT_PAGE;
      const rightSpillPage = RIGHT_PAGE;
      if (leftSpill && !rightSpill) {
        const extraPages = range(startPage - singleSpillOffset, startPage - 1);
        pages2 = [leftSpillPage, ...extraPages, ...pages2];
      } else if (!leftSpill && rightSpill) {
        const extraPages = range(endPage + 1, endPage + singleSpillOffset);
        pages2 = [...pages2, ...extraPages, rightSpillPage];
      } else if (leftSpill && rightSpill) {
        pages2 = [leftSpillPage, ...pages2, rightSpillPage];
      }
      return [1, ...pages2, totalPages];
    }
    return range(1, totalPages);
  };
  const pages = fetchPageNumbers();
  return pages.length > 0 ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("nav", __spreadValues({}, props), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledPagination, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PaginationButtonWrapper, __spreadValues({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_3__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName: "paging",
    contentName: "previousPage"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledPaginationBtn, {
    disabled: currentPage === 1
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PageLink, {
    onClick: handleMoveLeft,
    "aria-label": "Previous page"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_4__/* .SvgIcon */ .l, {
    name: "chevron-back",
    size: 12
  })))), pages.map((page, index) => {
    if ([LEFT_PAGE, RIGHT_PAGE].includes(page)) {
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DotItem, {
        key: index
      }, "...");
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PaginationButtonWrapper, __spreadValues({
      key: index
    }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_3__/* .getTrackingData */ .O5)({
      isTrackContent: true,
      regionName: "paging",
      contentName: "gotoPage",
      target: `${page}`
    })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledPaginationBtn, {
      active: currentPage === page
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PageLink, {
      onClick: (e) => handleClick(page, e),
      active: currentPage === page,
      "aria-label": "Next page"
    }, page)));
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PaginationButtonWrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledPaginationBtn, __spreadValues({
    disabled: currentPage === totalPages
  }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_3__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName: "paging",
    contentName: "nextPage"
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PageLink, {
    onClick: handleMoveRight
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_4__/* .SvgIcon */ .l, {
    name: "chevron-forward",
    size: 12
  })))))) : null;
};




/***/ }),

/***/ 732553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ Swiper; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(418668);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(672659);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(739794);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(909221);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(246626);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _atoms_SvgIcon_icons_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(172848);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(({ theme }) => `.swiper-container {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;
}
.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  transition-property: transform;
  box-sizing: content-box;
}
.swiper-slide {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  transition-property: transform;
}
&:hover {
  .swiper-button-next,
  .swiper-button-prev {
    opacity: 1;
    &.swiper-button-disabled {
      opacity: 0.35;
    }
  }
}
.swiper-button-prev,
.swiper-button-next {
  position: absolute;
  top: 50%;
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin-top: -22px;
  background-color: rgba(168, 168, 168, 0.46);
  opacity: 0;
  &.swiper-button-disabled {
    opacity: 0;
    cursor: auto;
    pointer-events: auto;
  }
}
.swiper-pagination {
position: absolute;
text-align: center;
transform: translate3d(0, 0, 0);
z-index: 10;
}
.swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 100%;
  background: #ddd;
}
.swiper-container-horizontal {
z-index: 0;
}
.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 0 4px;
  cursor: pointer;
}
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 10px;
  left: 0;
  width: 100%;
}
.swiper-pagination-bullet-active {
  background: ${theme.brand.secondary};
  width: 24px;
  border-radius: 8px;
}
.swiper-button-next {
  right: 0;
  left: auto;
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
  &:after {
    mask: url("${_atoms_SvgIcon_icons_es_js__WEBPACK_IMPORTED_MODULE_2__/* .iconMap["chevron-forward"] */ .q["chevron-forward"]}");
    content: ' ';
    height: 30px;
    width: 30px;
    mask-size: contain;
    display: inline-block;
    background: #333;
  }
}
.swiper-button-prev {
left: 0;
right: auto;
border-top-right-radius: 100px;
border-bottom-right-radius: 100px;
&:after {
  mask: url("${_atoms_SvgIcon_icons_es_js__WEBPACK_IMPORTED_MODULE_2__/* .iconMap["chevron-back"] */ .q["chevron-back"]}");
  content: ' ';
  height: 30px;
  width: 30px;
  mask-size: contain;
  display: inline-block;
  background: #333;
}
}`);
const Swiper = (_a) => {
  var _b = _a, {
    children,
    hasNavigation,
    hasPagination,
    className
  } = _b, props = __objRest(_b, [
    "children",
    "hasNavigation",
    "hasPagination",
    "className"
  ]);
  const swiperProps = Object.assign({}, props);
  if (hasNavigation && !props.navigation) {
    swiperProps.navigation = true;
    swiper_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"].use */ .Z.use([swiper_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z]);
  }
  if (hasPagination && !props.pagination) {
    swiperProps.pagination = true;
    swiper_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"].use */ .Z.use([swiper_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z]);
  }
  const { slidesPerView = "auto" } = swiperProps;
  const renderContent = (e, index, slidesPerView2) => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o, {
      style: {
        maxWidth: (slidesPerView2 === "auto" ? 100 : 100 / slidesPerView2) + "%"
      },
      key: index
    }, e);
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
    className
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(swiper_react__WEBPACK_IMPORTED_MODULE_7__/* .Swiper */ .t, __spreadValues({}, swiperProps), react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, (e, index) => renderContent(e, index, slidesPerView))));
};




/***/ }),

/***/ 295658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jj": function() { return /* binding */ getWindow; },
/* harmony export */   "Me": function() { return /* binding */ getDocument; }
/* harmony export */ });
/* unused harmony exports extend, ssrDocument, ssrWindow */
/**
 * SSR Window 3.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: November 9, 2020
 */
/* eslint-disable no-param-reassign */
function isObject(obj) {
    return (obj !== null &&
        typeof obj === 'object' &&
        'constructor' in obj &&
        obj.constructor === Object);
}
function extend(target, src) {
    if (target === void 0) { target = {}; }
    if (src === void 0) { src = {}; }
    Object.keys(src).forEach(function (key) {
        if (typeof target[key] === 'undefined')
            target[key] = src[key];
        else if (isObject(src[key]) &&
            isObject(target[key]) &&
            Object.keys(src[key]).length > 0) {
            extend(target[key], src[key]);
        }
    });
}

var ssrDocument = {
    body: {},
    addEventListener: function () { },
    removeEventListener: function () { },
    activeElement: {
        blur: function () { },
        nodeName: '',
    },
    querySelector: function () {
        return null;
    },
    querySelectorAll: function () {
        return [];
    },
    getElementById: function () {
        return null;
    },
    createEvent: function () {
        return {
            initEvent: function () { },
        };
    },
    createElement: function () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function () { },
            getElementsByTagName: function () {
                return [];
            },
        };
    },
    createElementNS: function () {
        return {};
    },
    importNode: function () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
};
function getDocument() {
    var doc = typeof document !== 'undefined' ? document : {};
    extend(doc, ssrDocument);
    return doc;
}

var ssrWindow = {
    document: ssrDocument,
    navigator: {
        userAgent: '',
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
    history: {
        replaceState: function () { },
        pushState: function () { },
        go: function () { },
        back: function () { },
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener: function () { },
    removeEventListener: function () { },
    getComputedStyle: function () {
        return {
            getPropertyValue: function () {
                return '';
            },
        };
    },
    Image: function () { },
    Date: function () { },
    screen: {},
    setTimeout: function () { },
    clearTimeout: function () { },
    matchMedia: function () {
        return {};
    },
    requestAnimationFrame: function (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame: function (id) {
        if (typeof setTimeout === 'undefined') {
            return;
        }
        clearTimeout(id);
    },
};
function getWindow() {
    var win = typeof window !== 'undefined' ? window : {};
    extend(win, ssrWindow);
    return win;
}




/***/ })

}]);